import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { AgreeCheckbox } from '@ertelecom/ui-react/components/FormCallback/styledCheckBox';
import { Wrapper, Title, Inputs, Name, Phone, ButtonBlock, Button, Message } from './styled';
import useSubmit from '~/src/components/WorkInHome/hooks/useSubmit';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';
import { ACTIONS, CATEGORIES, EVENTS } from '~/src/constants/analytics';
import { POLICY_PAGE_LINK } from '~/src/constants';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';

const Form = ({ cityDomain }) => {

    const [phone, setPhone] = useState({});
    const [name, setName] = useState({});
    const [beenStarted, setDataLayer] = useState(false);
    const [isValidInputs, setIsValidInputs] = useState(false);
    const [checkAgreement, setCheckAgreement] = useState(true);

    useEffect(() => {
        setIsValidInputs(phone.isValid && name.isValid);
    }, [phone, name]);

    const [{ status, isLoading, message }, doSubmit] = useSubmit(cityDomain);

    const onChangeHandler = (stateInput, _setState) => {
        // @TODO stateInput.value убрать из условия после фикса nameDecorator (useEffect onchange) UI react
        if (!beenStarted && stateInput.value !== undefined) {
            dataLayerForCBPhonePush({ action: ACTIONS.started, requestId: null });
            setDataLayer(true);
        }
        _setState(stateInput);
    };

    const submitHandler = e => {
        e.preventDefault();
        if (isValidInputs) {
            doSubmit({
                name: name.value,
                phone: phone.value
            });
        }
    };

    useEffect(() => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.applicationForm,
            action: checkAgreement ? ACTIONS.clickAgreeBtn : ACTIONS.clickDisagreeBtn,
        });
    }, [checkAgreement]);

    const onChangeAgreementHandler = useCallback(() => {
        setCheckAgreement(!checkAgreement);
    }, [checkAgreement]);

    return (
        <Wrapper onSubmit={e => submitHandler(e)} id='request'>
            {
                status && message
                    ?   <Message>{message}</Message>
                    : <>
                            <Title>
                                Оставьте заявку
                            </Title>
                            <Inputs>
                                <Name
                                    name='name'
                                    onChange={(stateInput) => onChangeHandler(stateInput, setName)}
                                    placeholder='Ваше имя'
                                    errorMessage='Ожидаются только буквы и дефисы'
                                />
                                <Phone
                                    name='phone'
                                    onChange={(stateInput) => onChangeHandler(stateInput, setPhone)}
                                    placeholder='Номер телефона'
                                    errorMessage='Введите телефон в формате +7 (999) 999-99-99'
                                />
                            </Inputs>
                            <ButtonBlock>
                                <Button text='Отправить заявку' disabled={!isValidInputs || isLoading || !checkAgreement}/>
                                <AgreeCheckbox
                                    data-test='agreement'
                                    id={uniqueId()}
                                    onChange={onChangeAgreementHandler}
                                    isChecked={checkAgreement}
                                    agreeUrl={POLICY_PAGE_LINK}/>
                            </ButtonBlock>
                        </>
            }
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain
});

export default connect(mapStateToProps)(Form);
